import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=54dd2c65&"
import script from "./Checkout.vue?vue&type=script&async=true&lang=js&"
export * from "./Checkout.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports